import { makeAutoObservable, runInAction } from 'mobx'
import agent from '../api/agent'
import { PostCreate, Post } from '../models/Post'
import { store } from './store'

export default class PostStore {
  postRegistry = new Map<string, Post>()

  myPostRegistry = new Map<string, Post>()

  editPosts: PostCreate | undefined = undefined

  constructor() {
    makeAutoObservable(this)
  }

  get posts() {
    return Array.from(this.postRegistry.values())
  }

  get usersPosts() {
    const posts = Array.from(this.myPostRegistry.values())

    return posts
  }

  selectPosts = (post: Post) => {
    const tag: string[] = []
    post.tags.map((c) => tag.push(c.tag))

    const postImages: any[] = post.postImages.map((image) => ({
      file: image.image,
      primary: image.primary,
      id: image.id,
    }))

    const postat: PostCreate = {
      id: post.id,
      title: post.title,
      description: post.description,
      category: post.category,
      price: post.price,
      address: post.address,
      rooms: post.rooms,
      meters: post.meters,
      city: post.city,
      zipCode: post.zipCode,
      slug: post.slug,
      country: post.country,
      currency: post.currency,
      type: post.type,
      tags: tag,
      postImages,
    }
    this.editPosts = postat
  }

  loadPosts = async () => {
    const { status, data: post } = await agent.Posts.list()
    if (status === 200) {
      runInAction(() => {
        post.forEach((iPost) => {
          this.postRegistry.set(iPost.id, iPost)
        })
      })
    }
  }

  loadMyPosts = async () => {
    const { status, data: result } = await agent.Posts.listMyPosts()
    if (status === 200) {
      runInAction(() => {
        result.forEach((post) => {
          this.myPostRegistry.set(post.id, post)
        })
      })
    }
  }

  createPosts = async (iPost: PostCreate, files: any, images: any) => {
    const formData = new FormData()
    formData.append('Id', iPost.id)
    formData.append('Title', iPost.title)
    formData.append('Description', iPost.description)
    formData.append('Category', iPost.category)
    formData.append('Price', iPost.price.toString())
    formData.append('Rooms', iPost.rooms.toString())
    formData.append('Meters', iPost.meters.toString())
    formData.append('Type', iPost.type!.toString())
    formData.append('Address', iPost.address)
    formData.append('Country', iPost.country!.toString())
    formData.append('Currency', iPost.currency!.toString())
    formData.append('City', iPost.city)
    formData.append('ZipCode', iPost.zipCode.toString())

    iPost.tags.forEach((tag, index) => {
      formData.append(`Tags[${index}]`, tag)
    })

    images.forEach((image: any, index: any) => {
      const isPrimary = files.find((file: any) => file.preview === image.preview)?.primary ?? false
      formData.append(`PostImages[${index}].File`, image)
      formData.append(`PostImages[${index}].Primary`, isPrimary.toString())
    })

    await agent.Posts.create(formData)
  }

  updatePost = async (edit: PostCreate, files: any, images: any) => {
    const formData = new FormData()

    formData.append('Id', edit.id)
    formData.append('Title', edit.title)
    formData.append('Description', edit.description)
    formData.append('Category', edit.category)
    formData.append('Price', edit.price?.toString())
    formData.append('Rooms', edit.rooms?.toString())
    formData.append('Meters', edit.meters?.toString())
    formData.append('Type', edit.type?.toString() as string)
    formData.append('Address', edit.address)
    formData.append('City', edit.city)
    formData.append('ZipCode', edit.zipCode?.toString())

    edit.tags.forEach((tag, index) => {
      formData.append(`Tags[${index}]`, tag)
    })

    images.forEach((image: any, index: any) => {
      const isPrimary = files.find((file: any) => file.preview === image.preview)?.primary ?? false
      formData.append(`PostImages[${index}].File`, image)
      formData.append(`PostImages[${index}].Primary`, isPrimary.toString())
      formData.append(`PostImages[${index}].Id`, image.id)
      if (image.preview) {
        formData.append(`PostImages[${index}].Preview`, image.preview)
      }
    })

    const { status, data: post } = await agent.Posts.update(edit.id, formData)
    if (status === 200) {
      runInAction(() => {
        store.postListStore.postRegistry.set(post.id, post)
      })
    }
  }

  deletePosts = async (id: string) => {
    await agent.Posts.delete(id)
    runInAction(() => {
      store.postListStore.postRegistry.delete(id)
    })
  }
}
